import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'url',
})
export class UrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    if (value.match(/^https?:\/\//)) {
      return value;
    }

    return `https://${value}`;
  }
}
